export type categoriesState = {
  imagesArr: string[];
  categories: string[];
};

export const RESET_CATEGORIES = 'categories/RESET_CATEGORIES';

export const GET_CATEGORIES = 'categories/GET_CATEGORIES';
export const GET_CATEGORIES_SUCCESS = 'categories/GET_CATEGORIES_SUCCESS';
